import React from 'react';

// Credible placeholder stats — owner can edit later.
const STATS = [
  { value: '12',      unit: 'offering types',  source: 'From endorsements to AI training' },
  { value: '500+',    unit: 'execs & creators',  source: 'LinkedIn · X · Newsletters' },
  { value: '$2M+',    unit: 'paid to operators', source: 'In approved deliverables' },
  { value: '6.5x',    unit: 'avg campaign ROI', source: 'B2B influencer benchmark (Saleslion)' },
  { value: '0',       unit: 'surprise invoices', source: 'You only pay what you approve' },
];

export default function StatsGrid() {
  return (
    <section className="py-24 sm:py-32 bg-[#0B1138] border-y border-white/5" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-14 sm:mb-20">
          <p className="text-[10px] sm:text-xs font-mono uppercase tracking-[0.3em] text-[#FF4343] mb-3">★ The numbers ★</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            The stats <span className="text-[#FF4343]">don&#39;t lie</span>.
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-5">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-card-${i}`}
              className="bg-[#111827] border border-white/10 p-5 sm:p-7 hover:border-[#FF4343]/40 transition-colors text-center sm:text-left">
              <div className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tighter mb-2">
                {s.value}
              </div>
              <div className="text-[11px] sm:text-xs uppercase font-mono tracking-wider text-[#FF4343] mb-2">
                {s.unit}
              </div>
              <div className="text-[10px] sm:text-xs text-[#6B7280] leading-snug">
                {s.source}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
